import React from 'react';

const RFQStatusBadge = ({ status }) => {
  const getStatusConfig = (status) => {
    switch (status?.toLowerCase()) {
      case 'submitted':
        return {
          label: 'Submitted',
          className: 'bg-blue-100 text-blue-800 border-blue-200',
          dotColor: 'bg-blue-500'
        };
      case 'under_review':
        return {
          label: 'Under Review',
          className: 'bg-yellow-100 text-yellow-800 border-yellow-200',
          dotColor: 'bg-yellow-500'
        };
      case 'quoted':
        return {
          label: 'Quoted',
          className: 'bg-green-100 text-green-800 border-green-200',
          dotColor: 'bg-green-500'
        };
      case 'accepted':
        return {
          label: 'Accepted',
          className: 'bg-emerald-100 text-emerald-800 border-emerald-200',
          dotColor: 'bg-emerald-500'
        };
      case 'declined':
        return {
          label: 'Declined',
          className: 'bg-red-100 text-red-800 border-red-200',
          dotColor: 'bg-red-500'
        };
      case 'expired':
        return {
          label: 'Expired',
          className: 'bg-gray-100 text-gray-800 border-gray-200',
          dotColor: 'bg-gray-500'
        };
      default:
        return {
          label: 'Unknown',
          className: 'bg-gray-100 text-gray-800 border-gray-200',
          dotColor: 'bg-gray-500'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium border ${config?.className}`}>
      <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${config?.dotColor}`}></span>
      {config?.label}
    </span>
  );
};

export default RFQStatusBadge;